//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'
import { cloneDeep, getMyCountry } from '~/assets/js/utils.js'
export default {
  data () {
    return {
      linkDom: '', // 外链dom
      isHover: false, // 鼠标是否移入选择国家
      countryList: [], // 悬浮框国家列表
      mySearch: '', // 用户输入的国家
      searchCounryList: [], // 搜索到的国家
      dialogVisible: false, // 是否展示弹框
      showMNation: true, // 是否展示国家列表弹框（移动端）
      timeIn: '', // 移入时间点
      timeOut: '', // 移出时间点
      toIn: '', // 移入延时器
      toOut: '' // 移出延时器
    }
  },
  computed: {
    ...mapState(['isMobile', 'suffix', 'contact', 'ipNation', 'selectNation']),
    // 面包屑导航——首页
    breadHost () {
      return this.$store?.getters?.breadHome
    },
    // 本项目logo
    fxLogo () {
      if (this.isCn()) return 'https://resources.interface003.com/web20/img/home/logo-cn.svg'
      else if (this.isHK()) return 'https://resources.interface003.com/web20/img/home/logo-tw.svg'
      else return 'https://resources.interface003.com/web20/img/home/logo-en.svg'
    },
    // 用户选择的国家是否和IP定位的国家一致
    isMyNation () {
      return this.ipNation?.countryCode != this.selectNation?.countryCode
    }
  },
  watch: {
    '$store.state.cookieVal' () {
      this.setLinkDom()
    }
  },
  created () {
    this.timeIn = this.timeOut = new Date()
    // 处理外链dom
    this.setLinkDom()
    this.countryList = this.$store?.state?.countryList
  },
  mounted () {
    window.showRiskPop = () => {
      this.dialogVisible = true
    }
  },
  beforeDestroy () {
    window.showRiskPop = null
    clearTimeout(this.toIn)
    clearTimeout(this.toOut)
  },
  methods: {
    setLinkDom () {
      const cookieVal = this.$store.state?.cookieVal
      const cookieParam = cookieVal ? `?contentcookie=${encodeURIComponent(cookieVal)}` : ''
      const linkList = [
        { name: this.$t('TYY_000240'), url: `${this.breadHost}about.html` }, // 关于我们
        { name: this.$t('TYY_000081') }, // 风险提示
        { name: this.$t('22487'), url: `${this.breadHost}terms.html?type=1` }, // 使用条款
        { name: this.$t('22488'), url: `${this.breadHost}terms.html?type=3` }, // 隐私声明
        { name: this.$t('22489'), url: `${this.breadHost}TraderSearch_Open.html` }, // 搜索调用
        { name: this.$t('22490'), url: `https://www.wikifxmanager.com/${this.currLangCode()}/login${cookieParam}` }, // 企业版(天眼号)
        { name: this.$t('22491'), url: `https://v${this.$store.getters?.halfHost}/${this.currLangCode()}/` }, // 官方验证
        { name: 'WikiEXPO', url: `https://www.wikiexpo.com/${this.currLangCode()}/` },
        { name: this.$t('22492'), url: `https://www.wikiresearch.com/${this.currLangCode()}/` } // 天眼研究院
      ]
      let linkDom = ''
      linkList?.forEach((item) => {
        if (item.url) linkDom += `<a href="${item.url}" target="_blank" class="single-link">${item.name}</a><i class="segment">|</i>`
        else linkDom += `<a href="javascript:;" onclick="showRiskPop()" class="single-link">${item.name}</a><i class="segment">|</i>`
      })
      this.linkDom = linkDom
    },
    // 更换国家
    countryFn (obj = {}) {
      const abbr = obj?.twoCharCode?.toLowerCase() || ''
      const specialList = [ // 特殊国家，直接切换到对应的语言
        { lang: 'de', country: 'de' },
        { lang: 'en', country: 'au' },
        { lang: 'en', country: 'uk' },
        { lang: 'en', country: 'us' },
        { lang: 'es', country: 'es' },
        { lang: 'fr', country: 'fr' },
        { lang: 'id', country: 'id' },
        { lang: 'ja', country: 'jp' },
        { lang: 'pt', country: 'pt' },
        { lang: 'th', country: 'th' },
        { lang: 'tr', country: 'tr' },
        { lang: 'vi', country: 'vn' },
        { lang: 'zh-cn', country: 'cn' },
        { lang: 'zh', country: 'hk' },
        { lang: 'zh', country: 'tw' }
      ]
      const { lang = '' } = specialList.find(item => item.country == abbr) || {}
      this.$store.commit('setCountryCode', getMyCountry({ twoCharCode: abbr?.toUpperCase() })?.countryCode || '840')
      this.$cookies.set('CountryCode', abbr, this.$store.getters.cookConf)
      if (lang) {
        const { name = '', query = '' } = this.$route
        const params = this.$route.params || {}
        params.lang = lang
        const routeData = this.$router.resolve({ name, params, query })
        location.href = routeData?.href
        return true
      }
      this.$nextTick(() => { location.reload(true) }) // 页面刷新
    },
    // 搜索国家
    async searchCountry () {
      if (!this.mySearch?.trim()?.length) { // 暂未输入
        this.searchCounryList = []
        return false
      }
      if (this.isReq) return false // 接口正在请求中
      this.isReq = true // 请求开始
      try {
        const res = await this.$api.home.countrySearch({ content: this.mySearch })
        this.searchCounryList = cloneDeep(res || [])
      } catch (err) {}
      this.isReq = false // 请求结束
    },
    // 鼠标移入移出事件
    countryPop (value = 0) {
      if (!value) { // 鼠标移出事件
        this.timeOut = new Date()
        clearTimeout(this.toIn)
        this.toOut = setTimeout(() => {
          this.slideUp(this.timeIn, this.timeOut)
        }, 100)
      } else { // 鼠标移入事件
        this.timeIn = new Date()
        clearTimeout(this.toOut)
        this.toIn = setTimeout(() => {
          this.slideDown(this.timeIn, this.timeOut)
        }, 300)
      }
    },
    // 展示国家选择框
    slideDown (timeIn, timeOut) {
      if (parseInt(timeIn) < parseInt(timeOut) && parseInt(timeIn) + 300 >= parseInt(timeOut)) return false // 300毫秒内离开切换不生效
      this.isHover = true
    },
    // 隐藏国家选择框
    slideUp (timeIn, timeOut) {
      if (parseInt(timeOut) < parseInt(timeIn) && parseInt(timeOut) + 300 >= parseInt(timeIn)) return false // 300毫秒内离开切换不生效
      this.isHover = false
      this.mySearch = ''
      this.searchCounryList.length = 0
    }
  }
}
